import { render, staticRenderFns } from "./profitLossCarryForwardList.vue?vue&type=template&id=140b1c19&scoped=true"
import script from "./profitLossCarryForwardList.vue?vue&type=script&lang=js"
export * from "./profitLossCarryForwardList.vue?vue&type=script&lang=js"
import style0 from "./profitLossCarryForwardList.vue?vue&type=style&index=0&id=140b1c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b1c19",
  null
  
)

export default component.exports